import { render, staticRenderFns } from "./pdv.vue?vue&type=template&id=6f51fb8a&scoped=true"
import script from "./pdv.vue?vue&type=script&lang=js"
export * from "./pdv.vue?vue&type=script&lang=js"
import style0 from "./pdv.vue?vue&type=style&index=0&id=6f51fb8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f51fb8a",
  null
  
)

export default component.exports